// import { connect } from 'react-redux';
import useUser from 'hooks/useUser';

const HasPermission = ({ permission, children, fallback = null }) => {
  const { hasPermission } = useUser();
  return hasPermission(permission) ? children : fallback;
};

export default HasPermission;
